import { Row, Col, Divider, Avatar, Typography, Space, Dropdown } from "antd";

const HeaderMain = () => {
  const items = [
    {
      key: "1",
      label: <a onClick={() => {}}>Đổi mật khẩu</a>,
    },
    {
      key: "2",
      label: (
        <a
          onClick={() => {
            localStorage.clear();
            window.location.href = "/login";
          }}
        >
          Đăng xuất
        </a>
      ),
    },
  ];

  const userName = localStorage.getItem("username");

  return (
    <div className="headerMain-container">
      <Row justify={"space-between"} align={"middle"}>
        <Col>
          <Space
            style={{ width: "100%", height: "100%" }}
            direction="horizontal"
            split={<Divider type="vertical" />}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Dropdown arrow={true} menu={{ items }} placement="bottom">
                <Avatar size="large" style={{ backgroundColor: "#CA5442" }}>
                  {userName?.toLocaleUpperCase().charAt(0)}
                </Avatar>
              </Dropdown>
              <Typography className="account-name">{userName}</Typography>
            </div>
          </Space>
        </Col>
      </Row>
    </div>
  );
};

export default HeaderMain;
